export default __webpack_public_path__ + "static/media/Path3502.305d9b6f.svg";